import React from 'react';
import { ROUTE_NAMES } from '../../Routes';
import { Helmet } from 'react-helmet-async';
import { Link, useLocation } from 'react-router-dom';

import P_1 from '../../assets/press/Press-1-1.png';
import P_2 from '../../assets/press/Press-2-1.webp';
import P_3 from '../../assets/press/Press-3-1.jpg';
import P_5 from '../../assets/press/Press-6-1.jpg';

export default function PressPage5() {
  const location = useLocation();
  const canonicalUrl = `https://www.thestarlifegroup.com${location.pathname}`;

  const pressList = [
    {
      image: P_1,
      title:
        'Starlife: Construction Starts on ’21 Hollywood’ at 2100 N. Federal Highway, Hollywood, FL, 33020',
      link: ROUTE_NAMES.PRESS1,
    },
    {
      image: P_2,
      title:
        '21 Hollywood, a new 13-story mixed-use apartment development is coming to the heart of Hollywood',
      link: ROUTE_NAMES.PRESS2,
    },
    {
      image: P_3,
      title:
        'Exclusive & Iconic: Starlife Group’s 21 Hollywood Recognized as the Best in Luxury Real Estate',
      link: ROUTE_NAMES.PRESS3,
    },
  ];

  return (
    <div className='press-single-page'>
      <Helmet>
        <title>
          Starlife: Starlife Group Founder and CEO Gevorg Shahbazyan Named Young
          Developer of the Year at the Red Awards Florida 2025
        </title>
        <meta
          name='description'
          content='Stay updated with Starlife Group’s latest news, real estate insights, investment trends, and project announcements.'
        />
        <meta
          name='keywords'
          content='Starlife press, Real estate news, Luxury property updates, Real estate investment insights, Starlife Group announcements, Property market trends'
        />
        <link rel='canonical' href={canonicalUrl} />
      </Helmet>
      <div className='col-1'>
        <img src={P_5} alt='press-image' />
        <h2 className='press-page-title'>
          Starlife Group Founder and CEO Gevorg Shahbazyan Named Young Developer
          of the Year at the Red Awards Florida 2025
        </h2>
        <span className='author-name'>By Daylight Time</span>
        <span className='author-name'>Mar 11, 2025</span>
        <Link
          to={
            'https://www.businesswire.com/news/home/20250311620336/en/Starlife-Group-Founder-and-CEO-Gevorg-Shahbazyan-Named-Young-Developer-of-the-Year-at-the-Red-Awards-Florida-2025'
          }
        >
          <span className='author-name'>Source</span>
        </Link>

        <div className='press-page-content'>
          <p>
            MIAMI--(BUSINESS WIRE)--Gevorg Shahbazyan, Founder and CEO of
            Starlife Group and Companies, a leading real estate development
            firm, was recognized as Young Developer of the Year at the Red
            Awards Florida 2025 on February 27 in Miami. The Red Awards honor
            excellence in real estate, architecture, hospitality, and
            construction through prestigious awards, networking events, and
            industry recognition.
          </p>
          <p>
            Shahbazyan is a visionary real estate developer and entrepreneur
            with a decade of experience shaping Miami’s dynamic real estate
            market. As the Founder and CEO of Starlife Group and Companies, he
            has led the firm’s expansion into multifamily, mixed-use, and
            commercial developments, both in South Florida and internationally.
          </p>
          <p>
            “I am deeply honored by this recognition, which reflects not just an
            individual effort, but the collective vision, trust, and hard work
            of everyone at Starlife Group,” Shahbazyan said. “This milestone
            stands as a testament to the strength of our partnerships, the
            dedication of our team, and the unwavering belief that real estate
            is more than just development – it’s about building long-term
            value.”
          </p>
          <p>
            Starlife is currently developing the 21 Hollywood apartment project
            on a 1.48-acre site in Hollywood, Fla. Designed by Kobi Karp
            Architecture, the 13-story tower will feature 200 apartments, 10,000
            square feet of retail space and an array of amenities, including a
            pool deck, game room, fitness center with a yoga/pilates room,
            wellness center, dog park and more. The project, which broke ground
            in late 2024, is expected to be completed in early 2027.
          </p>
          <p>
            Under Shahbazyan’s leadership, Starlife Group has grown to include
            Starlife Builders, which is serving as general contractor for 21
            Hollywood, Starlife Capital Ventures, and Starlife International
            Realty, with a diverse portfolio that spans luxury residential
            rental buildings, hotels, and over 75 townhomes.
          </p>
          <p>
            Shahbazyan holds a master’s degree in Global Affairs from Florida
            International University and is the author of “Inside the Mind of a
            Real Estate Developer,” offering valuable insights into the
            industry.
          </p>
          <p>About Starlife Group</p>
          <p>
            Starlife Group is a leading real estate development firm committed
            to shaping the future of urban living, blending innovation,
            sustainability, and excellence to create properties that elevate
            luxury and functionality. Backed by cutting-edge design, strategic
            investments, and expert construction, Starlife develops projects
            that set new market standards and deliver lasting value for
            investors, homeowners, and communities.
          </p>
          <p>
            Since 2018, Starlife Group has grown into a fully integrated real
            estate powerhouse, seamlessly managing development, sales,
            construction, lending, and capital ventures. The company’s portfolio
            spans South Florida and Europe, featuring large-scale multifamily
            projects, mixed-use developments, luxury spec homes, townhouses, and
            commercial properties.
          </p>
          <p>
            From concept to completion, Starlife builds with purpose — creating
            impactful properties that redefine modern living. For more
            information, visit thestarlifegroup.com.
          </p>
        </div>
      </div>
      <div className='col-2'>
        <div className='sticky-press-list'>
          <h3>Press Articles</h3>
          {pressList.map((item, idx) => (
            <Link to={item.link} key={idx}>
              <div className='other-press-card'>
                <img src={item.image} alt={`press-${idx}`} />
                <p>{item.title}</p>
              </div>
            </Link>
          ))}
          <Link to={ROUTE_NAMES.PRESS}>
            <button className='view-all-press-btn'>View All</button>
          </Link>
        </div>
      </div>
    </div>
  );
}
